<span class="workflow-summary__sr-only" aria-live="polite" aria-atomic="true">
  {{ politeAnnouncement }}
</span>
<section class="workflow-summary" [class.workflow-summary--compact]="compact" aria-label="Workflow context"
  [attr.aria-busy]="state === 'loading' ? 'true' : null" [attr.data-state]="state"
  [attr.data-tone]="state === 'ready' && ledger ? statusTone : null"
  [attr.data-expanded]="expanded ? 'true' : 'false'" data-testid="workflow-summary-bar">
  <div class="workflow-summary__identity"><ng-content select="[summaryIdentity]" /></div>
  <div *ngIf="state !== 'ready' || !ledger; else workflowSummary" class="workflow-summary__state">
    <span class="workflow-summary__state-mark" aria-hidden="true"></span>
    <span [attr.role]="state === 'error' ? 'alert' : 'status'">{{ stateMessage }}</span>
  </div>
  <ng-template #workflowSummary>
    <ng-container *ngIf="ledger as workflow">
      <div class="workflow-summary__stage">
        <span class="workflow-summary__label">Current stage</span>
        <strong [title]="currentStepLabel">{{ currentStepLabel }}</strong>
        <span class="workflow-summary__status-chip" [attr.data-tone]="statusTone">{{ workflow.statusLabel }}</span>
        <span class="workflow-summary__workflow" [title]="workflow.workflowLabel">{{ workflow.workflowLabel }}</span>
      </div>
      <div class="workflow-summary__responsibility">
      <div class="workflow-summary__owner" [attr.data-unassigned]="isUnassigned" [title]="'Assigned to ' + currentOwnerLabel" data-testid="workflow-current-assignee">
        <span class="workflow-summary__label">Assigned to</span>
        <strong>{{ currentOwnerLabel }}</strong>
      </div>
      <span *ngIf="currentQueueLabel" class="workflow-summary__queue" data-testid="workflow-current-queue">Queue: {{ currentQueueLabel }}</span>
      </div>
      <div class="workflow-summary__attention" [attr.data-attention]="hasAttention" data-testid="workflow-attention">
        <span class="workflow-summary__label">{{ attentionLabel }}</span>
        <button *ngIf="hasAttention && showToggle; else attentionText" type="button" class="workflow-summary__attention-link"
          [title]="attentionTitle" [attr.aria-controls]="disclosureControls" [attr.aria-expanded]="expanded"
          (click)="openDetails()">{{ attentionDetail }}<span *ngIf="pendingDecisions.length > 1"> +{{ pendingDecisions.length - 1 }} more</span></button>
        <ng-template #attentionText><span [title]="attentionTitle">{{ attentionDetail }}</span></ng-template>
        <span *ngIf="dueUtc as due" class="workflow-summary__deadline" [attr.data-overdue]="isOverdue">{{ isOverdue ? 'Overdue · due' : 'Due' }} <time [attr.datetime]="due" [title]="formatDateTime(due)">{{ shortDate(due) }}</time></span>
      </div>
      <div class="workflow-summary__progress" [attr.aria-label]="progressAriaLabel">
        <span>{{ progressLabel }}</span>
        <span *ngIf="stageStartedUtc as started" class="workflow-summary__timing" data-testid="workflow-stage-start">In stage since <time [attr.datetime]="started" [title]="formatDateTime(started)">{{ shortDate(started) }}</time></span>
        <span *ngIf="workflow.lastActivityUtc as activity" class="workflow-summary__timing">Last activity <time [attr.datetime]="activity" [title]="formatDateTime(activity)">{{ shortDate(activity) }}</time></span>
      </div>
      <button *ngIf="showToggle" type="button" class="workflow-summary__toggle"
        [attr.aria-expanded]="expanded" [attr.aria-controls]="disclosureControls"
        [attr.aria-label]="toggleLabel" (click)="toggleExpanded()">
        <span>Details &amp; history</span>
        <span class="workflow-summary__chevron" aria-hidden="true"></span>
      </button>
      <dl *ngIf="expanded || !showToggle" class="workflow-summary__details" [id]="detailsId" data-testid="workflow-summary-details">
        <div><dt>Workflow instance</dt><dd>{{ workflow.workflowInstanceId }}</dd></div>
        <div *ngIf="workflow.versionLabel"><dt>Version</dt><dd>{{ workflow.versionLabel }}</dd></div>
      </dl>
    </ng-container>
  </ng-template>
</section>
